import { createFileRoute, redirect } from '@tanstack/react-router';
import { getDefaultTargetMonth } from '@/features/contract-and-cost/targetMonth';
export const Route = createFileRoute('/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/cost/')({
  beforeLoad: ({
    params
  }) => {
    throw redirect({
      to: '/software/$id/contract-and-cost/cost/$targetMonth',
      params: {
        id: params.id,
        targetMonth: getDefaultTargetMonth()
      }
    });
  }
});